import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/pages/website/layout'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/main',
    meta:{ index: 0},
    children: [
      {
        path: 'main',
        name: 'Main',
        meta:{ keepAlive: true, index: 1},
        component: resolve=>(require(["@/pages/website/main"],resolve))
      },
      {
        path: 'product',
        name: 'Product',
        meta:{ keepAlive: true, index: 1},
        component: resolve=>(require(["@/pages/website/product"],resolve))
      },
      {
        path: 'invite',
        name: 'Invite',
        meta:{ keepAlive: true, index: 1},
        component: resolve=>(require(["@/pages/website/invite"],resolve))
      },
      {
        path: 'about',
        name: 'About',
        meta:{ keepAlive: true, index: 1},
        component: resolve=>(require(["@/pages/website/about"],resolve))
      },
      {
        path: 'service',
        name: 'Service',
        meta:{ keepAlive: true, index: 1},
        component: resolve=>(require(["@/pages/website/service"],resolve))
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/404')
  }
]

const router = new VueRouter({
  routes: routes,
  mode: 'history',
  base: '/website/'
})

export default router